import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

type Props = {
  isSimulation: boolean;
  successTotal?: number;
  failTotal?: number;
  examFinished?: boolean;
  pageTitle: string;
  setTimeOut?: () => void;
};

export default ({
  isSimulation,
  successTotal,
  failTotal,
  examFinished,
  pageTitle,
  setTimeOut,
}: Props) => {
  const totalTime = useRef(90 * 60);
  const interval = useRef<NodeJS.Timer>();
  const [timer, setTimer] = useState('01:30:00');

  const getTimeRemaining = () => {
    const hours = Math.floor(totalTime.current / 3600);
    const minutes = Math.floor((totalTime.current - hours * 3600) / 60);
    const seconds = totalTime.current - hours * 3600 - minutes * 60;

    totalTime.current -= 1;

    return { hours, minutes, seconds };
  };

  const getDisplayTime = (hours: number, minutes: number, seconds: number) => {
    const dHours = hours < 10 ? `0${hours}` : hours;
    const dMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const dSeconds = seconds < 10 ? `0${seconds}` : seconds;

    return `${dHours}:${dMinutes}:${dSeconds}`;
  };

  const updateTimer = () => {
    const { hours, minutes, seconds } = getTimeRemaining();
    if (totalTime.current >= 0) {
      setTimer(getDisplayTime(hours, minutes, seconds));
    } else {
      setTimer('00:00:00');
      if (interval.current) clearInterval(interval.current);
      if (setTimeOut) setTimeOut();
    }
  };

  const startTimer = () => {
    if (interval.current) clearInterval(interval.current);
    interval.current = setInterval(() => {
      updateTimer();
    }, 1000);
  };

  useEffect(() => {
    if (isSimulation) {
      startTimer();
    }
    return () => clearInterval(interval.current);
  }, [isSimulation]);

  useEffect(() => {
    if (examFinished && interval.current) {
      clearInterval(interval.current);
    }
  }, [examFinished]);

  return (
    <div className="menu">
      <Link to="/">Home</Link>
      <div className="page">{pageTitle}</div>
      <div />

      {isSimulation && (
        <div className="info">
          <div className="success-answers">
            Correct:&nbsp;
            <span>{successTotal}</span>
          </div>
          <div className="fail-answers">
            Incorrect:&nbsp;
            <span>{failTotal}</span>
          </div>
          <div className="timer">
            Timer:&nbsp;
            <span>{timer}</span>
          </div>
        </div>
      )}
    </div>
  );
};
